const BACKEND_URL = process.env.VUE_APP_OPERATIONS_BACKEND_URL

export { BACKEND_URL }
